function variantJSUpdate() {
  const variantLists = document.querySelectorAll('.custom-variant-list-product-card');

  const formatMoney = (amount,currency) => {
    return (Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(amount, window.Shopify.currency.active_format || "${{amount}}")
      : `${currency}${(amount / 100).toFixed(2)}`;
  };

  variantLists.forEach(list => {
    const buttons = list.querySelectorAll('.custom-variant-option-product-card');    

    const productJsonEl = list.previousElementSibling?.matches('[data-product-json]')
      ? list.previousElementSibling
      : document.querySelector('[data-product-json]');

    let productData = null;
    if (productJsonEl) {
      try {
        productData = JSON.parse(productJsonEl.textContent);
      } catch (e) {
        console.warn('Invalid product JSON', e);
      }
    }

    buttons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
 
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        let variantImage = "";
        if (productData && productData.images && productData.images[index]) {
          variantImage = productData.images[index];
        }

        const selectedVariant = {
          id: btn.dataset.id,
          sku: btn.dataset.sku,
          barcode: btn.dataset.barcode,
          title: btn.dataset.title,
          price: parseInt(btn.dataset.price, 10),
          image: btn.dataset.image || variantImage,
          name: btn.dataset.name,
          index: index,
          currency:btn.dataset.currency,
          inventory: btn.dataset.inventory,
          isBestseller: btn.dataset.isbestseller === "true",
          isNew: btn.dataset.introductiondate,
          isOnDisplay: btn.dataset.isondisplay === "true",
          dateDuration: btn.dataset.dateduration,
          storefrontKey: btn.dataset.storefrontkey,
          storefrontversion: btn.dataset.storefrontversion,
          customerCurrentLocation: btn.dataset.currentlocation,
          specificationPdf: btn.dataset.specificationpdf,
          instructionPdf: btn.dataset.instructionpdf,
          pickupInfo: btn.dataset.pickupinfo
        };             

        const card = btn.closest('.product-card, .grid__item, .card-wrapper') || document;
        const variantId = selectedVariant.id;
        const productLinks = card.querySelectorAll('.product-card-link');

        productLinks.forEach(link => {
          const baseUrl = link.dataset.productUrl;

          if (!baseUrl || !variantId) return;
          const cleanUrl = baseUrl.split('?')[0];
          link.href = `${cleanUrl}?variant=${variantId}`;
        });

        const availabilityText = card.querySelector('.pickup-delivery-container .delivery-availability');        
        const availabilityTextList = card.querySelector('.product-card-list-right-top .pickup-delivery-container .delivery-availability');

        const pickupInfo = btn.dataset.pickupinfo || "";
        const pickupOptions = pickupInfo.split('|').map(v => v.trim());

        const hasCarrierDelivery = pickupOptions.includes('Carrier Delivery');
        const hasLocalDelivery = pickupOptions.includes('Local Delivery');
        const hasStorePickup = pickupOptions.includes('Store Pickup');

        if (hasCarrierDelivery) {
            availabilityText.textContent = "Available";
            availabilityTextList.textContent = "Available";
        } else {
            availabilityText.textContent = "Not Available";
            availabilityTextList.textContent = "Not Available";
        }

        const instructionLink = card.querySelector('.product-card-list-right-top .instruction-pdf .instruction-pdf-link');
        const specificationLink = card.querySelector('.product-card-list-right-top .specificiation-pdf .specificiation-pdf-link');       

        if (selectedVariant.specificationPdf && specificationLink) {        
          specificationLink.href = selectedVariant.specificationPdf;
        }

        if (selectedVariant.instructionPdf && instructionLink) {      
          instructionLink.href = selectedVariant.instructionPdf;
        }        
        

       getStoreAvailability(selectedVariant.id, selectedVariant.storefrontKey, selectedVariant.storefrontversion).then(data => {
        const edges = data?.data?.node?.storeAvailability?.edges || [];
        const currentLocation = selectedVariant.customerCurrentLocation?.toLowerCase() || "";

        const inventoryUpdate = card.querySelector('.pickup-delivery-container .inventory-available');
        const inventoryUpdateList = card.querySelector('.product-card-list-right-top .pickup-delivery-container .inventory-available');        
                

        let qty = 0; // default

        if (currentLocation.trim() !== "") {
          const matchedStore = edges.find(edge => {
            const storeLocation = edge.node.location.storeLocation.reference;
            const title = storeLocation.label?.value || storeLocation.name?.value || '';

            return title.toLowerCase().includes(currentLocation);
          });

          if (matchedStore) {
            qty = Math.max(matchedStore.node.quantityAvailable, 0);
          }
        } else {
          console.log("currentLocation empty → Forcing 0");
        }

        if (inventoryUpdate) {
          inventoryUpdate.textContent = qty;
          inventoryUpdateList.textContent = qty;          

          // if (qty == 0) {
          //   availabilityText.textContent = "Not Available";
          //   availabilityTextList.textContent = "Not Available";
          // } else {
          //   availabilityText.textContent = "Available";
          //   availabilityTextList.textContent = "Available";
          // }
        }
      });        


        const bestSellerBadge = card.querySelector('.custom-product-badges .badge--bestseller');
        const onDisplayBadge = card.querySelector('.custom-product-badges .badge--ondisplay');
        const newBadge = card.querySelector('.custom-product-badges .badge--new');

        if (bestSellerBadge) {
          bestSellerBadge.style.display = selectedVariant.isBestseller ? "block" : "none";
        }

        if (onDisplayBadge) {
          onDisplayBadge.style.display = selectedVariant.isOnDisplay ? "block" : "none";
        }

        const isNewProduct = (() => {
          if (!selectedVariant.isNew) return false;
          const introDate = new Date(selectedVariant.isNew);
          if (isNaN(introDate)) return false;

          const today = new Date();
          const diffDays = (today - introDate) / (1000 * 60 * 60 * 24);
          const allowedDays = parseInt(selectedVariant.dateDuration, 10) || 30;

          return diffDays >= 0 && diffDays <= allowedDays;
        })();


        if (newBadge) {
          newBadge.style.display = isNewProduct ? "block" : "none";
        }      

        const titleEl = card.querySelector('.product-card__title .reversed-link__text');
        if (titleEl && selectedVariant.name) {
          titleEl.textContent = selectedVariant.name;
        }

        const barcodeUpdate = card.querySelector('.barcode-sku-details .barcode-details-number');
        const barcodeContainer = card.querySelector('.barcode-sku-details .barcode-details');
        if (barcodeUpdate && selectedVariant.barcode) {
          barcodeContainer.style.display = "block";
          barcodeUpdate.textContent = selectedVariant.barcode;
        }else{
          if(barcodeContainer){
            barcodeContainer.style.display = "none";
          }
        }

        const skuUpdate = card.querySelector('.barcode-sku-details .sku-details-number');
        if (skuUpdate && selectedVariant.sku) {
          skuUpdate.textContent = selectedVariant.sku;
        }

        const priceEl = card.querySelector('.f-price-item--regular');
        if (priceEl && selectedVariant.price) {
          priceEl.textContent = formatMoney(selectedVariant.price,selectedVariant.currency);
        }

        const form = card.querySelector('form.product-card__actions');
        if (form) {
          const variantInput = form.querySelector('input.product-variant-id[name="id"]');
          if (variantInput) {
            variantInput.value = selectedVariant.id;
          }
        }

        const formList = card.querySelector('.product-card-list-form form.product-card__actions');
        if (formList) {
          const variantInput = formList.querySelector('input.product-variant-id[name="id"]');
          if (variantInput) {
            variantInput.value = selectedVariant.id;
          }
        }

        const wishlistVariantUpdate =card.querySelector('.custom-wishlist-button');
        const wishlistVariantUpdateList =card.querySelector('.product-card__list-actions .custom-wishlist-button');        
        if (wishlistVariantUpdate) {
          wishlistVariantUpdate.dataset.variantId = selectedVariant.id;
          wishlistVariantUpdateList.dataset.variantId = selectedVariant.id;
        }        

        const imageWrapper = card.querySelector(
          '.media-wrapper.product-card__image.product-card__image--main img'
        );

        if (imageWrapper && selectedVariant.image) {
          const cleanSrc = selectedVariant.image.split('?')[0];

          imageWrapper.src = `${cleanSrc}?width=539`;
          imageWrapper.srcset = `
            ${cleanSrc}?width=70 70w,
            ${cleanSrc}?width=140 140w,
            ${cleanSrc}?width=165 165w,
            ${cleanSrc}?width=355 355w,
            ${cleanSrc}?width=450 450w,
            ${cleanSrc}?width=535 535w,
            ${cleanSrc}?width=539 539w
          `.trim();

          imageWrapper.style.opacity = 0;
          setTimeout(() => {
            imageWrapper.style.opacity = 1;
          }, 150);
        }
      });
    });

    const quickShopBtn = list.querySelector('.quick-shop-drawer-button');
    if (quickShopBtn && !quickShopBtn.dataset.bound ) {

      quickShopBtn.dataset.bound = "true";
      
      quickShopBtn.addEventListener('click', async function (event) {
        event.preventDefault();

        const productHandleValue = productData?.handle;
        if (!productHandleValue) {
          console.warn('Product handle missing');
          return;
        }        

        const sectionIdValue = `quick-shop`;
        try {
          const response = await fetch(`/products/${productHandleValue}?sections=${sectionIdValue}`);
          const json = await response.json();                  
          const html = json[sectionIdValue];

          // const container = document.querySelector("#QuickViewContainer");
          // const html = await response.text();
          // container.innerHTML = html;

          const drawer = document.querySelector("#quickShopDrawer");    
          if(!drawer) return
          
          const drawerBody = drawer.querySelector(`#quickShopDrawerBody-${drawer.dataset.sectionId}`);

          drawer.removeAttribute("hidden");
          drawer.setAttribute("open", "");
          drawer.setAttribute("active", "");
          document.body.classList.add("modal-show");
          drawerBody.innerHTML = html;
        } catch (error) {
          console.error("Error fetching quick view:", error);
        }
      });
    }

  });
}

setTimeout(()=>{
  variantJSUpdate();
},2000)


document.querySelectorAll('.product-card, .grid__item, .card-wrapper').forEach(card => {

  const firstActiveBtn = card.querySelector('.custom-variant-option-product-card.active');
  if (!firstActiveBtn) return;

  const selectedVariant = {
    id: firstActiveBtn.dataset.id,
    storefrontKey: firstActiveBtn.dataset.storefrontkey,
    storefrontversion: firstActiveBtn.dataset.storefrontversion,
    customerCurrentLocation: firstActiveBtn.dataset.currentlocation
  };

  getStoreAvailability(selectedVariant.id, selectedVariant.storefrontKey, selectedVariant.storefrontversion).then(data => {
    const edges = data?.data?.node?.storeAvailability?.edges || [];
    const currentLocation = selectedVariant.customerCurrentLocation?.toLowerCase() || "";

    const inventoryUpdate = card.querySelector('.pickup-delivery-container .inventory-available');
    const inventoryUpdateList = card.querySelector('.product-card-list-right-top .pickup-delivery-container .inventory-available');       

    let qty = 0; // default

    if (currentLocation.trim() !== "") {

      const matchedStore = edges.find(edge => {
        const storeLocation = edge.node.location.storeLocation.reference;
        const title = storeLocation.label?.value || storeLocation.name?.value || '';

        return title.toLowerCase().includes(currentLocation);            
      });

      if (matchedStore) {
        qty = Math.max(matchedStore.node.quantityAvailable, 0);
      }
    } else {
      console.log("currentLocation empty → Forcing 0");
    }

    if (inventoryUpdate) {
      inventoryUpdate.textContent = qty;
      inventoryUpdateList.textContent = qty;          

      // if (qty == 0) {
      //   availabilityText.textContent = "Not Available";
      //   availabilityTextList.textContent = "Not Available";
      // } else {
      //   availabilityText.textContent = "Available";
      //   availabilityTextList.textContent = "Available";
      // }
    }
  });

});


document.addEventListener('shopify:section:load', variantJSUpdate);
document.addEventListener('DOMContentLoaded', variantJSUpdate);
document.addEventListener("facets:updated", variantJSUpdate);
document.addEventListener("facets:updated", () => {
  setTimeout(variantJSUpdate, 50); // allow DOM to settle
});


document.addEventListener("click", function (event) {
  const btn = event.target.closest(".custom-variant-option-product-card");
  if (!btn) return;
  const card = btn.closest('.product-card, .grid__item, .card-wrapper');
  if (!card) return;

  variantJSUpdate(); 
});
